import { PayloadAction } from "@reduxjs/toolkit";

import { tablePaginationInitialValue } from "@sso/constant";
import { MergeOrgsType, OrganisationState, SearchColumn } from "@sso/types";
import { getTableSortColumn } from "@sso/utils";

import { organisationInitialState } from "./initialState";

export const organisationReducer = {
  setOrganisationPageSize: (organisations: OrganisationState, action: PayloadAction<number>) => {
    organisations.pagination.pageIndex = tablePaginationInitialValue.pageIndex;
    organisations.pagination.pageSize = action.payload;
  },
  setOrganisationPageIndex: (organisations: OrganisationState, action: PayloadAction<number>) => {
    organisations.pagination.pageIndex = action.payload;
  },
  setOrganisationSearchColumn: (organisations: OrganisationState, action: PayloadAction<SearchColumn>) => {
    organisations.pagination.pageIndex = tablePaginationInitialValue.pageIndex;
    organisations.pagination.search[action.payload.column] = action.payload;
  },
  clearOrganisationSearchColumn: (organisations: OrganisationState, action: PayloadAction<string>) => {
    const { [action.payload]: deleteItem, ...otherSearchItems } = organisations.pagination.search;
    organisations.pagination.search = otherSearchItems;
  },
  setOrganisationSortColumn: (organisations: OrganisationState, action: PayloadAction<string>) => {
    const { column, type } = organisations.pagination.sort;
    organisations.pagination.sort = getTableSortColumn(column, action.payload, type);
    organisations.pagination.pageIndex = organisationInitialState.pagination.pageIndex;
  },
  addOrganisationToMergeArray: (organisations: OrganisationState, action: PayloadAction<MergeOrgsType>) => {
    organisations.mergeOrgs.push(action.payload);
  },
  removeOrganisationFromMergeArray: (organisations: OrganisationState, action: PayloadAction<number>) => {
    organisations.mergeOrgs = organisations.mergeOrgs.filter(org => org.id !== action.payload);
  },
  clearOrganisationMergeArray: (organisations: OrganisationState) => {
    organisations.mergeOrgs = [];
  },
};
